import { CommonTLFModule } from '../../common/common.module';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormAmiantoComponent } from './form-amianto/form-amianto.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TagInputModule } from 'ngx-chips';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormAmiantoGiudizialeComponent } from './form-amianto-giudiziale/form-amianto-giudiziale.component';
import { DynamicComponentService } from './services/dynamic-component.service';
import { FormAppelloComponent } from './form-appello/form-appello.component';
import { FormArbitratoComponent } from './form-arbitrato/form-arbitrato.component';
import { FormAzioneMonitoriaComponent } from './form-azione-monitoria/form-azione-monitoria.component';
import { FormOpposizioneDecretoIngiuntivoComponent } from './form-opposizione-decreto-ingiuntivo/form-opposizione-decreto-ingiuntivo.component';
import { FormRicorsoCassazioneComponent } from './form-ricorso-cassazione/form-ricorso-cassazione.component';
import { FormRicorsoLavoroComponent } from './form-ricorso-lavoro/form-ricorso-lavoro.component';
import { FormRicorsoOpposizioneComponent } from './form-ricorso-opposizione/form-ricorso-opposizione.component';
import { FormRitoForneroComponent } from './form-rito-fornero/form-rito-fornero.component';
import { FormTentativoObbligatorioConciliazioneComponent } from './form-tentativo-obbligatorio-conciliazione/form-tentativo-obbligatorio-conciliazione.component';
import { FormAmiantoViewComponent } from './form-amianto/view/form-amianto-view.component';
import { FormRicorsoOpposizioneViewComponent } from './form-ricorso-opposizione/view/form-ricorso-opposizione-view.component';
import { FormRicorsoLavoroViewComponent } from './form-ricorso-lavoro/view/form-ricorso-lavoro-view.component';
import { FormTentativoObbligatorioConciliazioneViewComponent } from './form-tentativo-obbligatorio-conciliazione/view/form-tentativo-obbligatorio-conciliazione-view.component';
import { FormAppelloViewComponent } from './form-appello/view/form-appello-view.component';
import { FormRitoForneroViewComponent } from './form-rito-fornero/view/form-rito-fornero-view.component';
import { FormAmiantoGiudizialeViewComponent } from './form-amianto-giudiziale/view/form-amianto-giudiziale-view.component';
import { FormRicorsoCassazioneViewComponent } from './form-ricorso-cassazione/view/form-ricorso-cassazione-view.component';
import { FormOpposizioneDecretoIngiuntivoViewComponent } from './form-opposizione-decreto-ingiuntivo/view/form-opposizione-decreto-ingiuntivo-view.component';
import { FormAzioneMonitoriaViewComponent } from './form-azione-monitoria/view/form-azione-monitoria-view.component';
import { FormArbitratoViewComponent } from './form-arbitrato/view/form-arbitrato-view.component';
import { FormEsecuzioneViewComponent } from './form-esecuzione/view/form-esecuzione-view.component';
import { FormEsecuzioneComponent } from './form-esecuzione/form-esecuzione.component';
import { FormSpecialeViewComponent } from './form-speciale/view/form-speciale-view.component';
import { FormSpecialeComponent } from './form-speciale/form-speciale.component';
import { FormRecuperoCreditiStragiudizialeViewComponent } from './form-recupero-crediti-stragiudiziale/view/form-recupero-crediti-stragiudiziale-view.component';
import { FormRecuperoCreditiStragiudizialeComponent } from './form-recupero-crediti-stragiudiziale/form-recupero-crediti-stragiudiziale.component';
import { FormPrecettoViewComponent } from './form-precetto/view/form-precetto-view.component';
import { FormPrecettoComponent } from './form-precetto/form-precetto.component';
import { FormOrdinarioViewComponent } from './form-ordinario/view/form-ordinario-view.component';
import { FormOrdinarioComponent } from './form-ordinario/form-ordinario.component';
import { FormMobiliareViewComponent } from './form-mobiliare/view/form-mobiliare-view.component';
import { FormMobiliareComponent } from './form-mobiliare/form-mobiliare.component';
import { FormImmobiliareViewComponent } from './form-immobiliare/view/form-immobiliare-view.component';
import { FormImmobiliareComponent } from './form-immobiliare/form-immobiliare.component';
import { FormCoterziViewComponent } from './form-coterzi/view/form-coterzi-view.component';
import { FormCoterziComponent } from './form-coterzi/form-coterzi.component';
import { FormCautelareViewComponent } from './form-cautelare/view/form-cautelare-view.component';
import { FormCautelareComponent } from './form-cautelare/form-cautelare.component';
import { FormConciliazioneStragiudizialeViewComponent } from './form-conciliazione-stragiudiziale/view/form-conciliazione-stragiudiziale-view.component';
import { FormConciliazioneStragiudizialeComponent } from './form-conciliazione-stragiudiziale/form-conciliazione-stragiudiziale.component';
import { FormPrevidenzialeViewComponent } from './form-previdenziale/view/form-previdenziale-view.component';
import { FormPrevidenzialeComponent } from './form-previdenziale/form-previdenziale.component';
import { FormRicorsoAmministrativoComponent } from './form-ricorso/form-ricorso.component';
import { FormRicorsoAmministrativoViewComponent } from './form-ricorso/view/form-ricorso-view.component';
import { FormNegoziazioneAssistitaComponent } from './form-negoziazione-assistita/form-negoziazione-assistita.component';
import { FormNegoziazioneAssistitaViewComponent } from './form-negoziazione-assistita/view/form-negoziazione-assistita-view.component';
import { FormGenericoComponent } from './form-generico/form-generico.component';
import { FormGenericoViewComponent } from './form-generico/view/form-generico-view.component';


@NgModule({
  imports: [
    CommonTLFModule,
    CommonModule,
    RouterModule,
    NgbModule,
    FormsModule,
    ReactiveFormsModule,
    TagInputModule,
    NgSelectModule,
  ],
  entryComponents: [
    FormAmiantoComponent,
    FormAmiantoViewComponent,
    FormAmiantoGiudizialeComponent,
    FormAmiantoGiudizialeViewComponent,
    FormAppelloComponent,
    FormAppelloViewComponent,
    FormArbitratoComponent,
    FormArbitratoViewComponent,
    FormAzioneMonitoriaComponent,
    FormAzioneMonitoriaViewComponent,
    FormOpposizioneDecretoIngiuntivoComponent,
    FormOpposizioneDecretoIngiuntivoViewComponent,
    FormRicorsoCassazioneComponent,
    FormRicorsoCassazioneViewComponent,
    FormRicorsoLavoroComponent,
    FormRicorsoLavoroViewComponent,
    FormRicorsoOpposizioneComponent,
    FormRicorsoOpposizioneViewComponent,
    FormRitoForneroComponent,
    FormRitoForneroViewComponent,
    FormTentativoObbligatorioConciliazioneComponent,
    FormTentativoObbligatorioConciliazioneViewComponent,
    FormCautelareComponent,
    FormCautelareViewComponent,
    FormCoterziComponent,
    FormCoterziViewComponent,
    FormImmobiliareComponent,
    FormImmobiliareViewComponent,
    FormMobiliareComponent,
    FormMobiliareViewComponent,
    FormOrdinarioComponent,
    FormOrdinarioViewComponent,
    FormPrecettoComponent,
    FormPrecettoViewComponent,
    FormRecuperoCreditiStragiudizialeComponent,
    FormRecuperoCreditiStragiudizialeViewComponent,
    FormPrevidenzialeComponent,
    FormPrevidenzialeViewComponent,
    FormSpecialeComponent,
    FormSpecialeViewComponent,
    FormEsecuzioneComponent,
    FormEsecuzioneViewComponent,
    FormConciliazioneStragiudizialeComponent,
    FormConciliazioneStragiudizialeViewComponent,
    FormRicorsoAmministrativoComponent,
    FormRicorsoAmministrativoViewComponent,
    FormNegoziazioneAssistitaComponent,
    FormNegoziazioneAssistitaViewComponent,
    FormGenericoComponent,
    FormGenericoViewComponent,
  ],
  declarations: [
    FormAmiantoComponent,
    FormAmiantoViewComponent,
    FormAmiantoGiudizialeComponent,
    FormAmiantoGiudizialeViewComponent,
    FormAppelloComponent,
    FormAppelloViewComponent,
    FormArbitratoComponent,
    FormArbitratoViewComponent,
    FormAzioneMonitoriaComponent,
    FormAzioneMonitoriaViewComponent,
    FormOpposizioneDecretoIngiuntivoComponent,
    FormOpposizioneDecretoIngiuntivoViewComponent,
    FormRicorsoCassazioneComponent,
    FormRicorsoCassazioneViewComponent,
    FormRicorsoLavoroComponent,
    FormRicorsoLavoroViewComponent,
    FormRicorsoOpposizioneComponent,
    FormRicorsoOpposizioneViewComponent,
    FormRitoForneroComponent,
    FormRitoForneroViewComponent,
    FormTentativoObbligatorioConciliazioneComponent,
    FormTentativoObbligatorioConciliazioneViewComponent,
    FormCautelareComponent,
    FormCautelareViewComponent,
    FormCoterziComponent,
    FormCoterziViewComponent,
    FormImmobiliareComponent,
    FormImmobiliareViewComponent,
    FormMobiliareComponent,
    FormMobiliareViewComponent,
    FormOrdinarioComponent,
    FormOrdinarioViewComponent,
    FormPrecettoComponent,
    FormPrecettoViewComponent,
    FormRecuperoCreditiStragiudizialeComponent,
    FormRecuperoCreditiStragiudizialeViewComponent,
    FormPrevidenzialeComponent,
    FormPrevidenzialeViewComponent,
    FormSpecialeComponent,
    FormSpecialeViewComponent,
    FormEsecuzioneComponent,
    FormEsecuzioneViewComponent,
    FormConciliazioneStragiudizialeComponent,
    FormConciliazioneStragiudizialeViewComponent,
    FormRicorsoAmministrativoComponent,
    FormRicorsoAmministrativoViewComponent,
    FormNegoziazioneAssistitaComponent,
    FormNegoziazioneAssistitaViewComponent,
    FormGenericoComponent,
    FormGenericoViewComponent,
  ],
  providers: [DynamicComponentService],
  exports: [
    FormAmiantoComponent,
    FormAmiantoViewComponent,
    FormAmiantoGiudizialeComponent,
    FormAmiantoGiudizialeViewComponent,
    FormAppelloComponent,
    FormAppelloViewComponent,
    FormArbitratoComponent,
    FormArbitratoViewComponent,
    FormAzioneMonitoriaComponent,
    FormAzioneMonitoriaViewComponent,
    FormOpposizioneDecretoIngiuntivoComponent,
    FormOpposizioneDecretoIngiuntivoViewComponent,
    FormRicorsoCassazioneComponent,
    FormRicorsoCassazioneViewComponent,
    FormRicorsoLavoroComponent,
    FormRicorsoLavoroViewComponent,
    FormRicorsoOpposizioneComponent,
    FormRicorsoOpposizioneViewComponent,
    FormRitoForneroComponent,
    FormRitoForneroViewComponent,
    FormTentativoObbligatorioConciliazioneComponent,
    FormTentativoObbligatorioConciliazioneViewComponent,
    FormCautelareComponent,
    FormCautelareViewComponent,
    FormCoterziComponent,
    FormCoterziViewComponent,
    FormImmobiliareComponent,
    FormImmobiliareViewComponent,
    FormMobiliareComponent,
    FormMobiliareViewComponent,
    FormOrdinarioComponent,
    FormOrdinarioViewComponent,
    FormPrecettoComponent,
    FormPrecettoViewComponent,
    FormRecuperoCreditiStragiudizialeComponent,
    FormRecuperoCreditiStragiudizialeViewComponent,
    FormPrevidenzialeComponent,
    FormPrevidenzialeViewComponent,
    FormSpecialeComponent,
    FormSpecialeViewComponent,
    FormEsecuzioneComponent,
    FormEsecuzioneViewComponent,
    FormConciliazioneStragiudizialeComponent,
    FormConciliazioneStragiudizialeViewComponent,
    FormRicorsoAmministrativoComponent,
    FormRicorsoAmministrativoViewComponent,
    FormNegoziazioneAssistitaComponent,
    FormNegoziazioneAssistitaViewComponent,
    FormGenericoComponent,
    FormGenericoViewComponent
  ],
})
export class FascicoloFormSharedModule { }
